module.exports = require("kaitai-struct/KaitaiStream");